import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ProductCategory } from '@logio/common-be-fe';
import { action, observable, runInAction, computed } from 'mobx';
import { StoreName } from '../StoreName';
import { BaseStore } from '../BaseStore';
import { ProductCategoryLayer } from '../../transportLayers/product/ProductCategoryLayer';
import { arrayToMap } from '../../../shared/utils';
/**
 * This store obtaining data of product categories.
 */

export var ProductCategoryStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(ProductCategoryStore, _BaseStore);

  function ProductCategoryStore() {
    var _this;

    _classCallCheck(this, ProductCategoryStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryStore).apply(this, arguments));
    _this.name = StoreName.ProductCategory;
    _this.productCategoryLayer = new ProductCategoryLayer();
    _this.list = new Map();
    /** Map of allowed categories for current user */

    _this.userCategoryList = new Map();
    _this.priceArchitectureStats = new Map();
    _this.releaseCategories = new Map();
    return _this;
  }

  _createClass(ProductCategoryStore, [{
    key: "getAll",

    /**
     * Will fetch all data for this page
     */
    value: function getAll() {
      var _this2 = this;

      return this.productCategoryLayer.findAll().then(function (productCategories) {
        runInAction(function () {
          productCategories.forEach(function (cat) {
            _this2.list.set(cat.id, cat);
          });
        });
        return _this2.list;
      });
    }
    /** Fetches only those categories which are allowed for current user */

  }, {
    key: "getAllForCurrentUser",
    value: function getAllForCurrentUser() {
      var _this3 = this;

      return this.productCategoryLayer.getAllForCurrentUser().then(function (productCategories) {
        runInAction(function () {
          _this3.userCategoryList = arrayToMap(productCategories);
        });
        return _this3.userCategoryList;
      });
    }
  }, {
    key: "getOne",
    value: function getOne(categoryId) {
      var _this4 = this;

      return this.productCategoryLayer.findOne(categoryId).then(function (productCategory) {
        runInAction(function () {
          _this4.list.set(productCategory.id, productCategory);
        });
        return productCategory;
      });
    }
  }, {
    key: "getCategoryStats",
    value: function getCategoryStats() {
      var _this5 = this;

      // FIXME: Weird catch block
      return this.productCategoryLayer.getCategoryStats().then(function (priceArchitectureStats) {
        runInAction(function () {
          priceArchitectureStats.forEach(function (stat) {
            _this5.priceArchitectureStats.set(stat.categoryId, stat);
          });
        });
        return _this5.priceArchitectureStats;
      }).catch(function () {
        return null;
      });
    }
  }, {
    key: "update",
    value: function update(productCategory) {
      var _this6 = this;

      return this.productCategoryLayer.update(productCategory).then(function (category) {
        runInAction(function () {
          _this6.list.set(category.id, category);
        });
      });
    }
  }, {
    key: "getManyByIds",
    value: function getManyByIds(ids) {
      var _this7 = this;

      return this.productCategoryLayer.getManyByIds(ids).then(function (productCategories) {
        runInAction(function () {
          _this7.list.clear();

          productCategories.forEach(function (cat) {
            _this7.list.set(cat.id, cat);
          });
        });
        return _this7.list;
      });
    }
  }, {
    key: "getRandomInt",
    value: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }, {
    key: "loadForRelease",
    value: function loadForRelease(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var productCategories;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.productCategoryLayer.getForRelease(releaseId);

              case 2:
                productCategories = _context.sent;
                this.setCategoriesForRelease(releaseId, productCategories);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "loadForSelloutRelease",
    value: function loadForSelloutRelease(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var productCategories;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.productCategoryLayer.getForSelloutRelease(releaseId);

              case 2:
                productCategories = _context2.sent;
                this.setCategoriesForRelease(releaseId, productCategories);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "loadForSiteRelease",
    value: function loadForSiteRelease(releaseId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var productCategories;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.productCategoryLayer.getForSiteRelease(releaseId);

              case 2:
                productCategories = _context3.sent;
                this.setCategoriesForRelease(releaseId, productCategories);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setCategoriesForRelease",
    value: function setCategoriesForRelease(releaseId, productCategories) {
      this.releaseCategories.set(releaseId, new Map(productCategories.map(function (category) {
        return [category.id, category];
      })));
    }
  }, {
    key: "getCategoriesForRelease",
    value: function getCategoriesForRelease(releaseId) {
      return this.releaseCategories.get(releaseId);
    }
  }, {
    key: "getCategoryForRelease",
    value: function getCategoryForRelease(releaseId, categoryId) {
      var categories = this.getCategoriesForRelease(releaseId);

      if (categories) {
        return categories.get(categoryId);
      }

      return undefined;
    }
  }, {
    key: "getRootCategoryForRelease",
    value: function getRootCategoryForRelease(releaseId) {
      var categories = this.releaseCategories.get(releaseId);

      if (categories) {
        return Array.from(categories.values()).find(function (category) {
          return !category.parentId;
        });
      }

      return undefined;
    }
  }, {
    key: "root",
    get: function get() {
      return Array.from(this.userCategoryList.size > 0 ? this.userCategoryList.values() : this.list.values()).find(function (category) {
        return !category.parentId;
      });
    }
  }]);

  return ProductCategoryStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Object)], ProductCategoryStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Object)], ProductCategoryStore.prototype, "userCategoryList", void 0);

__decorate([observable, __metadata("design:type", Object)], ProductCategoryStore.prototype, "priceArchitectureStats", void 0);

__decorate([observable, __metadata("design:type", ProductCategory)], ProductCategoryStore.prototype, "productCategoryDetail", void 0);

__decorate([observable, __metadata("design:type", Object)], ProductCategoryStore.prototype, "releaseCategories", void 0);

__decorate([computed, __metadata("design:type", ProductCategory), __metadata("design:paramtypes", [])], ProductCategoryStore.prototype, "root", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ProductCategoryStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ProductCategoryStore.prototype, "getAllForCurrentUser", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductCategoryStore.prototype, "getOne", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ProductCategoryStore.prototype, "getCategoryStats", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [ProductCategory]), __metadata("design:returntype", Promise)], ProductCategoryStore.prototype, "update", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [String, Array]), __metadata("design:returntype", void 0)], ProductCategoryStore.prototype, "setCategoriesForRelease", null);